import { Box } from '@mui/material';
import styled, { css } from 'styled-components';

import {
  TCardContainerProps,
  TGridContainerProps,
  TSlotProps,
} from '@/console/features/card-layout/card-layout.types';
import { CardRow } from '@/console/features/card-layout/components/card/card.styled';

const dragOverStyle = css`
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: ${({ theme }) => theme.spacing(3)};
    border: 2px dashed ${({ theme }) => theme.palette.primary.main};
    pointer-events: none;
    animation: pulse 1.5s infinite;
  }
`;

const pulseAnimation = css`
  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.02);
      opacity: 0.5;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

export const GridContainer = styled(Box)<TGridContainerProps>`
  && {
    display: grid;
    height: 100%;
    width: 100%;
    gap: ${({ theme, $hasGap }) => ($hasGap ? theme.spacing(2) : 'none')};
    grid-template-areas: ${({ $template }) =>
      `"${$template.split('\n').join('" "')}"`};
  }
`;

export const Slot = styled(Box)<TSlotProps>`
  && {
    grid-area: ${({ $area }) => $area};
    display: flex;
    gap: ${({ theme }) => theme.spacing(2)};
    // border: 2px dashed transparent; disabled for now -> will be needed for drag and drop
    transition: all 0.2s ease;
    border-radius: ${({ theme }) => theme.spacing(3)};
    position: relative;
    flex-direction: ${({ $area }) => ($area === 'RIGHT' ? 'column' : 'row')};
    height: 100%;

    &.invalid-drop {
      border-color: ${({ theme }) => theme.palette.status.red.stroke};
      background-color: ${({ theme }) => theme.palette.status.red.background};
    }

    &.drag-over {
      ${dragOverStyle}
    }

    ${pulseAnimation}
  }
`;

export const CardContainer = styled(Box)<TCardContainerProps>`
  && {
    order: ${({ $flexOrder }) => $flexOrder || 0};
    flex: 1;
    width: 100%;
    height: 100%;
    opacity: ${({ $isDragging }) => ($isDragging ? 0.5 : 1)};
    user-select: ${({ $isDragging }) => ($isDragging ? 'none' : 'auto')};
    border: 2px dashed transparent;
    position: relative;

    &.drag-over {
      ${dragOverStyle}
    }

    ${pulseAnimation};

    & ${CardRow}:last-child:after {
      border-bottom: none;
    }
  }
`;
